import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/quick')({
  beforeLoad: async () => {
    throw redirect({
      to: '/',
    });
  },
});
